import PropTypes from 'prop-types';
import React from 'react';

import { NEGATIVE_AMOUNT_FORMAT_LOCALES } from '../../utils/constants';

/* This component will wrap the children with discount amount format based on the locale */
const DiscountFormatter = ({ isNegative, children, storeLocale }) => {
  const isMinusFormat = NEGATIVE_AMOUNT_FORMAT_LOCALES.includes(storeLocale);
  if (isNegative) {
    return (
      <>
        {isMinusFormat ? '-' : '('}{children}{isMinusFormat ? '' : ')'}
      </>
    );
  }
  return children;
};

DiscountFormatter.defaultProps = {
  isNegative: false
};

DiscountFormatter.propTypes = {
  children: PropTypes.node.isRequired,
  isNegative: PropTypes.bool,
  storeLocale: PropTypes.string.isRequired
};

export default DiscountFormatter;
